import { EmptyState } from '@ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

/** Fallback for unknown paths. */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="not-found-title">
      <EmptyState
        size="page"
        level={1}
        title={t('notFound.title')}
        titleId="not-found-title"
        actions={<Link to="/">{t('notFound.back')}</Link>}
      />
    </section>
  );
}
